import { type BaseConfig, useConfig as hook } from '@eika-infrastruktur/config-provider';
import { nbTranslations, nnTranslations, type TranslationsConfigType } from '@translations';
import { type Links, links } from './config/links';

export interface Config extends BaseConfig {
    links: Links;
    siteLang: 'nb' | 'nn';
    translations: {
        nb: TranslationsConfigType;
        nn: TranslationsConfigType;
    };
}

export const defaultConfig: Config = {
    links,
    siteLang: 'nb' as const,
    translations: {
        nb: nbTranslations,
        nn: nnTranslations,
    },
};

function createHook<T>(): () => T {
    return () => hook<T>();
}

export const useConfig = createHook<typeof defaultConfig>();
